import script from "./LoadingBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingBox.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingBox.vue?vue&type=style&index=0&id=0cc6bc22&lang=postcss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc6bc22"]])

export default __exports__